// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1q-FG","col":"CardReaderDesc_col__2zZWu","label":"CardReaderDesc_label__24pW9"};